import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import BookingCard from "examples/Cards/BookingCard";

// Data
import reportsBarChartData from "layouts/dashboards/analytics/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboards/analytics/data/reportsLineChartData";
import dataTableDataAdmin from "./data/dataTableDataAdmin";
import dataTableDataUser from "./data/dataTableDataUser";

// Images
import booking1 from "assets/images/products/product-1-min.jpg";
import booking2 from "assets/images/products/product-2-min.jpg";
import booking3 from "assets/images/products/product-3-min.jpg";
import Card from "@mui/material/Card";
import {Link, useNavigate} from "react-router-dom";
import DataTable from "../../../examples/Tables/DataTable";
import {getUserIsLogin, getUserRole} from "../../../services/auth.service";
import MDButton from "../../../components/MDButton";
import dataTableData from "../sales/data/dataTableData";
import {useEffect} from "react";
import {userColumns, userDashboardColumns} from "../../../components/Utils/HeaderColumns";
import ClientsService from "../../../services/clients.service";
import MDBadge from "../../../components/MDBadge";
import GHIconButton from "../../../components/GHIconButton";
import {useState} from "react";
import AmenitiesService, { getMemberDashboard } from "../../../services/amenities.service";
import DashboardService from "../../../services/dashboard.service";
import PartyRoomService from "../../../services/partyRooms.service";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Image} from "react-bootstrap";
import {Dialog, DialogContent} from "@mui/material";
import Button from "@mui/material/Button";
import MDDatePicker from "../../../components/MDDatePicker";
import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import FormField from "../../pages/account/components/FormField";
import BasicFilteringGrid from "../../../examples/Tables/DataGridView";
import DataGridView from "../../../examples/Tables/DataGridView";
import {GridColDef, GridRowsProp} from "@mui/x-data-grid";
import {randomCreatedDate, randomTraderName, randomUpdatedDate} from "@mui/x-data-grid-generator";
import UserService from "../../../services/user.service";
import {modalStyle} from "../../../components/Utils/ModalStyle";
import MDAvatar from "../../../components/MDAvatar";
import CoreService from "../../../services/core.service";
import {LabelImportant} from "@mui/icons-material";
import dayjs from "dayjs";
import AdBanner from "../../../components/AdBanner";



function Analytics() {
    const { sales, tasks } = reportsLineChartData;
    useEffect(()=>{
    if(localStorage.getItem("is_first_refresh") === null ||
        localStorage.getItem("is_first_refresh") === undefined ||
        localStorage.getItem("is_first_refresh") === ""){
            localStorage.setItem("is_first_refresh", true);
            window.location.reload(true)
        }
    }, [])
    const getLastNDays = (n) =>{
        const today = new Date();
        const priorDate = new Date(new Date().setDate(today.getDate() - n));
        return priorDate.getFullYear().toString() + "-" + (priorDate.getMonth()+1).toString() + "-" + priorDate.getDate().toString()
    }

    const [qrCodeModuleShow, setQrCodeModuleShow] = useState(false);
    const [userInfoModuleShow, setUserInfoModuleShow] = useState(false);
    const [qrCodeData, setQrCodeData] = useState("");
    const handleClickOpenQrCode = () => {
        setQrCodeModuleShow(true);
    };
    const handleCloseQrCode = () => {
        setQrCodeModuleShow(false);
    };
    const handleClickOpenUserInfo = () => {
        setUserInfoModuleShow(true);
    };
    const handleCloseUserInfo = () => {
        setUserInfoModuleShow(false);
    };


    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedFirstName, setSelectedFirstName] = useState("")
    const [selectedLastName, setSelectedLastName] = useState("")
    const [selectedBuilding, setSelectedBuilding] = useState("")
    const [selectedClient, setSelectedClient] = useState("")
    const [selectedAddress, setSelectedAddress] = useState("")
    const [selectedPostalCode, setSelectedPostalCode] = useState("")
    const [selectedPhone, setSelectedPhone] = useState("")


    const renderModal = () => {
        return  <Dialog open={qrCodeModuleShow} onClose={handleCloseQrCode} aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                    <DialogContent>
                        <Image src={qrCodeData} width={512} height={512}/>
                        <MDButton size={"large"} src={""} color={"primary"} fullWidth>Download</MDButton>
                    </DialogContent>
            </Dialog>
    };
    const renderUserInfoModal = () => {
        return <Modal open={userInfoModuleShow}   color={"warning"} onClose={handleCloseUserInfo}>
          <MDBox sx={modalStyle}>
            <Card id="basic-info" sx={{ overflow: "visible" }}>
              <MDBox p={3} pb={2}>
                <MDTypography variant="h6">User Info ({selectedFirstName} {selectedLastName})</MDTypography>
              </MDBox>
              <MDBox component="form" pb={3}  >
                  <Grid container justifyContent={"center"} >
                    <Grid container spacing={2} pt={2} px={2} xs={12} md={12}   >

                        <Grid item xs={12} md={12}>
                            <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                <LabelImportant color={"warning"}  />
                                Name: {selectedFirstName} {selectedLastName}</MDTypography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <MDTypography fontWeight={"bold"}    >
                                <LabelImportant color={"warning"} />
                                Unit: {selectedUnit}</MDTypography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <MDTypography fontWeight={"bold"}    >
                                <LabelImportant color={"warning"} />
                                Client/Building: {selectedClient} / {selectedBuilding}</MDTypography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <MDTypography fontWeight={"bold"}    >
                                <LabelImportant color={"warning"} />
                                Postal: {selectedPostalCode}</MDTypography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                <LabelImportant color={"warning"} />
                                Phone: {selectedPhone}</MDTypography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                <LabelImportant color={"warning"} />
                                Address: {selectedAddress}</MDTypography>
                        </Grid>


                    </Grid>
                  </Grid>
              </MDBox>
            </Card>
          </MDBox>
        </Modal>
    };

    const clickOnRow = (e) =>{
        let target = e.target.getAttribute("rowname");
        if(target === "download"){
            let qr = e.target.getAttribute("qr");
            setQrCodeData(qr);
            handleClickOpenQrCode();
        }else if(target==="cancel"){
            if(window.confirm("do you want cancel this reservation booking ? ")){
                const cancellationMessage = window.prompt("Cancellation message to send to the member:", "");
                if (cancellationMessage === null) {
                    return;
                }
                const bookingType = e.target.getAttribute("bookingtype");
                const bookingId = e.target.getAttribute("bookingid") || e.target.getAttribute("id");
                const cancelRequest = bookingType === "party_room"
                    ? PartyRoomService.cancelBookPartyRoom(bookingId, cancellationMessage)
                    : AmenitiesService.cancelBooking(bookingId, cancellationMessage);
                cancelRequest
                    .then((data)=>{
                        // alert("ok");
                        window.location.reload(true);
                    }).catch((reason) =>{
                        alert(reason);
                    });
            }
        }
    }


    const [todayBooking, setTodayBooking] = useState(0);
    const [membersCount, setMembersCount] = useState(0);
    const [revenue, setRevenue] = useState(0);
    const [monthlyBooking, setMonthlyBooking] = useState(0);
    const [dailyRate, setDailyRate] = useState("0");
    const [busiestDay, setBusiestDay] = useState("-");
    const [busiestTime, setBusiestTime] = useState("-");
    const [busiestAmenity, setBusiestAmenity] = useState("-");
    const [busiestMember, setBusiestMember] = useState("-");
    const [busiestUnit, setBusiestUnit] = useState("-");

    // Member dashboard state
    const [myTotalBookings, setMyTotalBookings] = useState(0);
    const [myMonthlyBookings, setMyMonthlyBookings] = useState(0);
    const [upcomingCount, setUpcomingCount] = useState(0);
    const [favoriteAmenity, setFavoriteAmenity] = useState("-");
    const [favoriteAmenityId, setFavoriteAmenityId] = useState(null);
    const [upcomingBookings, setUpcomingBookings] = useState([]);
    const [popularAmenities, setPopularAmenities] = useState([]);
    const userRole = getUserRole();

    const isActivePartyRoomBooking = (booking) =>
        booking && booking.status !== "canceled" && booking.status !== "cancelled";

    const isUpcomingPartyRoomBooking = (booking) =>
        isActivePartyRoomBooking(booking) && !booking.is_past;

    const isCurrentMonthPartyRoomBooking = (booking) => {
        if (!booking?.date_full) return false;
        const bookingDate = dayjs(booking.date_full);
        return bookingDate.isValid() && bookingDate.isSame(dayjs(), "month");
    };

    const mapPartyRoomUpcomingBooking = (booking) => ({
        id: `party-${booking.id}`,
        amenity_name: booking.party_room,
        date: booking.date_full || booking.date,
        start_time: booking.start_time,
        end_time: booking.end_time,
        status: booking.status,
        booking_type: "Party Room",
    });

    const mapPartyRoomDashboardRow = (booking) => ({
        id: `party-${booking.id}`,
        booking_id: booking.id,
        booking_type: "party_room",
        full_name: booking.booking_name || "",
        member_account: "",
        booked_by: "",
        amenity_name: booking.party_room,
        status: booking.status,
        building: booking.building || "",
        booking_date: booking.date_full ? new Date(booking.date_full) : booking.date,
        booking_time: `${booking.start_time} - ${booking.end_time}`,
        status_color: booking.status === "confirmed" ? "success" : booking.status === "canceled" ? "dark" : "warning",
        price: 0,
        currency: "CAD",
        is_paid: true,
        payment_status: "Free",
        is_past: booking.is_past,
        user_unit: booking.unit || "",
        user_building: booking.building || "",
        user_postal_code: "",
        user_address: "",
        user_phone: "",
        first_name: booking.booking_name || "",
        last_name: "",
        email: booking.booking_email || "",
        client: booking.client || "",
    });

    useEffect(()=>DashboardService.getDashboard()
      .then((data)=>{
          setTodayBooking(data.data["today_booking"]);
          setMembersCount(data.data["member_count"]);
          setRevenue(data.data["all_revenue"]);
          setMonthlyBooking(data.data["monthly_booking"] || 0);
          setDailyRate(data.data["daily_rate"] || "0");
          setBusiestDay(data.data["busiest_day"] || "-");
          setBusiestTime(data.data["busiest_time"] || "-");
          setBusiestAmenity(data.data["busiest_amenity"] || "-");
          setBusiestMember(data.data["busiest_member"] || "-");
          setBusiestUnit(data.data["busiest_unit"] || "-");
          renderRows(30, 10)

      }).catch((reason)=>{
          console.log("error in fetching dashboard data" + reason);
      }),[])

    // Fetch member dashboard data for members
    useEffect(() => {
        if (userRole === "member") {
            Promise.allSettled([
                getMemberDashboard(),
                PartyRoomService.getMyPartyRoomBooking(),
            ])
                .then((results) => {
                    const data = results[0].status === "fulfilled" ? results[0].value.data : {};
                    const partyRoomBookings = results[1].status === "fulfilled" && Array.isArray(results[1].value.data)
                        ? results[1].value.data
                        : [];
                    const upcomingPartyRoomBookings = partyRoomBookings.filter(isUpcomingPartyRoomBooking);
                    setMyTotalBookings((data.my_total_bookings || 0) + partyRoomBookings.length);
                    setMyMonthlyBookings((data.my_monthly_bookings || 0) + partyRoomBookings.filter(isCurrentMonthPartyRoomBooking).length);
                    setUpcomingCount((data.upcoming_count || 0) + upcomingPartyRoomBookings.length);
                    setFavoriteAmenity(data.favorite_amenity || "-");
                    setFavoriteAmenityId(data.favorite_amenity_id || null);
                    setUpcomingBookings([
                        ...(data.upcoming_bookings || []),
                        ...upcomingPartyRoomBookings.map(mapPartyRoomUpcomingBooking),
                    ]);
                    setPopularAmenities(data.popular_amenities || []);
                    renderRows(30, 10);
                })
                .catch((err) => {
                    console.log("Error fetching member dashboard: " + err);
                    renderRows(30, 10);
                });
        }
    }, []);

    // const [currentRow, setCurrentRow] = useState({});
    const showDetails = (currentRow) => {
        // alert(currentRow)
        console.log(currentRow)
        // setCurrentRow(currentRow)
        handleClickOpenUserInfo()
        setSelectedUnit(currentRow.user_unit)
        setSelectedFirstName(currentRow.first_name)
        setSelectedLastName(currentRow.last_name)
        setSelectedBuilding(currentRow.user_building)
        setSelectedAddress(currentRow.user_address)
        setSelectedPostalCode(currentRow.user_postal_code)
        setSelectedPhone(currentRow.user_phone)
        setSelectedClient(currentRow.client)
        return <></>
    }
    const renderDetailsButton = (params ) =>{
        return (
            <Tooltip title={params.row.full_name || ""}>
                <MDButton
                    variant="text"
                    color="dark"
                    size="small"
                    style={{ marginLeft: 3, maxWidth: "100%", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", paddingLeft: 4, paddingRight: 4 }}
                    onClick={(e)=>{
                        showDetails(params.row)
                    }} >
                    {params.row.full_name}
                </MDButton>
            </Tooltip>
        )
    }
    const renderCancelButton = (params ) =>{
        if (params.row.booking_type === "party_room" && params.row.status !== "canceled" && !params.row.is_past){
            return (
                <strong>
                    <MDButton
                        variant="gradient"
                        color="warning"
                        size="small"
                        rowname={"cancel"}
                        id={params.row.booking_id}
                        bookingid={params.row.booking_id}
                        bookingtype={"party_room"}
                        style={{ marginLeft: 16 }}
                        onClick={clickOnRow}
                    >
                        Cancel
                    </MDButton>
                </strong>
            )
        }
        if (params.row.status === "confirmed"){
            return (
                <strong>
                    <MDButton
                        variant="gradient"
                        color="warning"
                        size="small"
                        rowname={"cancel"}
                        id={params.row.id}
                        bookingid={params.row.booking_id || params.row.id}
                        bookingtype={params.row.booking_type || "amenity"}
                        style={{ marginLeft: 16 }}
                        onClick={clickOnRow}
                    >
                        Cancel
                    </MDButton>
                </strong>
            )
        }

    }
    const renderStatus = (params ) =>{
        return (
            <strong>
                <MDBadge
                    variant="gradient"
                    badgeContent={params.row.status}
                    color={params.row.status_color}
                    size="small"
                    container
                />
            </strong>
        )
    }
    const renderPaymentStatus = (params) => {
        const price = params.row.price || 0;
        const isPaid = params.row.is_paid;
        const currency = params.row.currency || 'CAD';

        if (price > 0) {
            // Paid amenity
            if (isPaid) {
                return (
                    <MDBox display="flex" alignItems="center">
                        <Icon color="success" fontSize="small">check_circle</Icon>
                        <MDTypography variant="caption" ml={0.5} color="success">
                            Paid
                        </MDTypography>
                    </MDBox>
                );
            } else {
                return (
                    <Tooltip title={`$${price.toFixed(2)} ${currency} - Payment pending`}>
                        <MDBox display="flex" alignItems="center">
                            <Icon color="warning" fontSize="small">pending</Icon>
                            <MDTypography variant="caption" ml={0.5} color="warning">
                                Unpaid
                            </MDTypography>
                        </MDBox>
                    </Tooltip>
                );
            }
        }
        // Free amenity
        return (
            <MDBox display="flex" alignItems="center">
                <Icon color="info" fontSize="small">money_off</Icon>
                <MDTypography variant="caption" ml={0.5} color="text">
                    Free
                </MDTypography>
            </MDBox>
        );
    };
    const [columns, setColumns] = useState([
        {
            field: 'full_name',
            headerName: 'Booking name',
            width:145,
            renderCell: renderDetailsButton,
            editable: false,
            sortable: false,
            disableClickEventBubbling: true,
        },
        {
            field: 'member_account',
            headerName: 'Member account',
            width: 150,
            editable: false,
            valueFormatter: (params) => params.value || '—',
        },
        {
            field: 'user_unit',
            headerName: 'Unit',
            width: 75,
            editable: false,
            valueFormatter: (params) => params.value || '—',
        },
        {
            field: 'booked_by',
            headerName: 'Created by',
            width: 135,
            editable: false,
            valueFormatter: (params) => params.value || '—',
        },
        {
            field: 'amenity_name',
            headerName: 'Amenity',
            width:135,
            editable: false
        },
        {
            field: 'building',
            headerName: 'building',
            width:135,
            editable: false,
        },
        {
            field: 'booking_date',
            headerName: 'BookingDate',
            type: 'datetime',
            width:135,
            editable: false,
            valueFormatter: (params) => new dayjs(params.value).
                        subtract(-(new Date().getTimezoneOffset()), 'minutes').format('DD/MM/YYYY' ),
        },
        {
            field: 'booking_time',
            headerName: 'BookingTime',
            type: 'time',
            width:135,
            editable: false,
        },
        {
            field: 'payment_status',
            headerName: 'Payment',
            width:90,
            editable: false,
            renderCell: renderPaymentStatus,
            sortable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            width:110,
            editable: false,
            renderCell: renderStatus,
            disableClickEventBubbling: true,
            sortable: false,
        },
        {
            field: 'action',
            headerName: 'Action',
            width:105,
            editable: false,
            renderCell: renderCancelButton,
            sortable: false,
            disableClickEventBubbling: true,
        },
    ]);
    const [rows, setRows] = useState( []);

    const renderRows = (start, end) =>{
        const partyRoomRequest = userRole === "member"
            ? PartyRoomService.getMyPartyRoomBooking()
            : PartyRoomService.getMyPartyRoomBookingAdmin();
        Promise.allSettled([
            AmenitiesService.getBookings(getLastNDays(start), getLastNDays(-end)),
            partyRoomRequest,
        ])
            .then((results)=>{
                let tempRows  = [];
                const amenityResult = results[0].status === "fulfilled" ? results[0].value : null;
                const partyRoomResult = results[1].status === "fulfilled" ? results[1].value : null;
                if (amenityResult?.data !== undefined && amenityResult.data !== null){
                    amenityResult.data.forEach((data)=>{
                        tempRows.push({
                            id: data['id'],
                            booking_id: data['id'],
                            booking_type: "amenity",
                            full_name:data['full_name'],
                            member_account: [data['first_name'], data['last_name']].filter(Boolean).join(' '),
                            booked_by: data['booked_by'] || '',
                            amenity_name:data['amenity_name'],
                            status:data['status'],
                            building:data['building'],
                            booking_date:new Date(data['booking_date']),
                            booking_time:data['booking_time'],
                            status_color:data['status_color'],
                            user_unit: data['user_unit'],
                            user_building: data['user_building'],
                            user_postal_code: data['user_postal_code'],
                            user_address: data['user_address'],
                            user_phone: data['user_phone'],
                            first_name: data['first_name'],
                            last_name : data['last_name'],
                            email: data['email'],
                            client: data['client'],
                            price: data['price'],
                            currency: data['currency'],
                            is_paid: data['is_paid'],
                            payment_status: data['payment_status'],
                        });
                    });
                }
                if (Array.isArray(partyRoomResult?.data)) {
                    tempRows = [
                        ...tempRows,
                        ...partyRoomResult.data.map(mapPartyRoomDashboardRow),
                    ];
                }
                tempRows.sort((a, b) => new Date(b.booking_date) - new Date(a.booking_date));
                setRows(tempRows);
            }).catch((e)=>{
               console.log(e)
            });
    }
    const renderStaffDashboard = () => {
      return (<MDBox py={3}>
          {/* Ads Banner */}
          <AdBanner />

          {/* Row 1: Primary Stats - smaller cards */}
          <MDBox mt={1}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={4} lg={2}>
                <MiniStatisticsCard
                  title={{ text: "Today" }}
                  count={todayBooking}
                  icon={{ color: "info", component: "today" }}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={2}>
                <MiniStatisticsCard
                  title={{ text: "This Month" }}
                  count={monthlyBooking}
                  icon={{ color: "primary", component: "calendar_month" }}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={2}>
                <MiniStatisticsCard
                  title={{ text: "Daily Avg" }}
                  count={dailyRate}
                  icon={{ color: "success", component: "trending_up" }}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={2}>
                <MiniStatisticsCard
                  title={{ text: "Members" }}
                  count={membersCount}
                  icon={{ color: "warning", component: "people" }}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={2}>
                <MiniStatisticsCard
                  title={{ text: "Revenue" }}
                  count={`$${revenue}`}
                  icon={{ color: "success", component: "attach_money" }}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={2}>
                <MiniStatisticsCard
                  title={{ text: "Busiest Day" }}
                  count={busiestDay || "-"}
                  icon={{ color: "dark", component: "event" }}
                />
              </Grid>
            </Grid>
          </MDBox>
          {/* Row 2: Busiest Stats */}
          <MDBox mt={2}>
            <Grid container spacing={2}>
              <Grid item xs={6} md={4} lg={3}>
                <MiniStatisticsCard
                  title={{ text: "Busiest Time" }}
                  count={busiestTime || "-"}
                  icon={{ color: "info", component: "schedule" }}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <MiniStatisticsCard
                  title={{ text: "Top Amenity" }}
                  count={busiestAmenity || "-"}
                  icon={{ color: "error", component: "star" }}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <MiniStatisticsCard
                  title={{ text: "Top Member" }}
                  count={busiestMember || "-"}
                  icon={{ color: "warning", component: "person" }}
                />
              </Grid>
              <Grid item xs={6} md={4} lg={3}>
                <MiniStatisticsCard
                  title={{ text: "Top Unit" }}
                  count={busiestUnit || "-"}
                  icon={{ color: "primary", component: "apartment" }}
                />
              </Grid>
            </Grid>
          </MDBox>

          {renderModal()}
          {renderUserInfoModal()}
          <MDBox mt={4} mb={3}>
            <Card>
                <MDBox p={1} lineHeight={1}>
                    <MDTypography variant="h5" fontWeight="medium">
                      Bookings
                    </MDTypography>
                    <MDTypography variant="button" color="text">
                      Recent booking activity
                    </MDTypography>
                </MDBox>
                <MDBox p={3} lineHeight={1}>
                    <MDBox display="flex" flexWrap="wrap" gap={1} mb={2}>
                      <MDButton onClick={(e)=>renderRows(30, 10)} color={"primary"}
                                size={"small"} variant={"gradient"}>All</MDButton>

                      <MDButton onClick={(e)=>renderRows(30, 0)} color={"primary"}
                                size={"small"} variant={"gradient"}>Last 30 Days</MDButton>

                      <MDButton onClick={(e)=>renderRows(7, 0)} color={"primary"}
                                size={"small"} variant={"gradient"}>Last 7 Days</MDButton>

                      <MDButton onClick={(e)=>renderRows(1, 0)} color={"primary"}
                                size={"small"} variant={"gradient"}>Yesterday</MDButton>

                      <MDButton onClick={(e)=>renderRows(0, 0)} color={"primary"}
                                size={"small"} variant={"gradient"}>Today</MDButton>

                      <MDButton onClick={(e)=>renderRows(0, 1)} color={"primary"}
                                size={"small"} variant={"gradient"}>Tomorrow</MDButton>
                    </MDBox>

                    {rows.length === 0 ? (
                      <MDBox
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        py={6}
                      >
                        <Icon sx={{ fontSize: 48, color: "text.secondary", mb: 2 }}>event_note</Icon>
                        <MDTypography variant="h6" color="text" fontWeight="medium">
                          No Bookings Found
                        </MDTypography>
                        <MDTypography variant="body2" color="text" sx={{ mt: 1 }}>
                          No booking activity for the selected time period.
                        </MDTypography>
                      </MDBox>
                    ) : (
                      <DataGridView columns={columns} rows={rows}
                                    hideColumns={{
                                          user_phone: false,
                                          user_address: false,
                                          user_postal_code: false,
                                          user_building: false,
                                      }} />
                    )}
                </MDBox>
            </Card>
          </MDBox>
        </MDBox>)
    }

     const navigate = useNavigate();

     const renderUserDashboard = () => {
         const userColumns = [
             {
                 field: 'amenity_name',
                 headerName: 'Amenity',
                 width: 180,
                 editable: false
             },
             {
                 field: 'booking_date',
                 headerName: 'Date',
                 type: 'datetime',
                 width: 130,
                 editable: false,
                 valueFormatter: (params) => new dayjs(params.value).format('MMM D, YYYY'),
             },
             {
                 field: 'booking_time',
                 headerName: 'Time',
                 width: 130,
                 editable: false,
             },
             {
                 field: 'payment_status',
                 headerName: 'Payment',
                 width: 100,
                 editable: false,
                 renderCell: renderPaymentStatus,
                 sortable: false,
             },
             {
                 field: 'status',
                 headerName: 'Status',
                 width: 110,
                 editable: false,
                 renderCell: renderStatus,
                 sortable: false,
             },
             {
                 field: 'action',
                 headerName: 'Actions',
                 width: 200,
                 editable: false,
                 sortable: false,
                 renderCell: (params) => (
                     <MDBox display="flex" gap={1}>
                         {params.row.status === "confirmed" && (
                             <MDButton
                                 variant="gradient"
                                 color="warning"
                                 size="small"
                                 rowname="cancel"
                                 id={params.row.id}
                                 onClick={clickOnRow}
                             >
                                 Cancel
                             </MDButton>
                         )}
                         <MDButton
                             variant="outlined"
                             color="info"
                             size="small"
                             component={Link}
                             to={`/amenities/book?id=${params.row.amenity_id}`}
                         >
                             Rebook
                         </MDButton>
                     </MDBox>
                 ),
             },
         ];

         return (
             <MDBox py={3}>
                 {/* Ads Banner */}
                 <AdBanner />

                 {/* Row 1: Member Analytics Cards */}
                 <MDBox mt={1}>
                     <Grid container spacing={2}>
                         <Grid item xs={6} md={3}>
                             <MiniStatisticsCard
                                 title={{ text: "My Total Bookings" }}
                                 count={myTotalBookings}
                                 icon={{ color: "info", component: "event_note" }}
                             />
                         </Grid>
                         <Grid item xs={6} md={3}>
                             <MiniStatisticsCard
                                 title={{ text: "This Month" }}
                                 count={myMonthlyBookings}
                                 icon={{ color: "primary", component: "calendar_month" }}
                             />
                         </Grid>
                         <Grid item xs={6} md={3}>
                             <MiniStatisticsCard
                                 title={{ text: "Upcoming" }}
                                 count={upcomingCount}
                                 icon={{ color: "success", component: "upcoming" }}
                             />
                         </Grid>
                         <Grid item xs={6} md={3}>
                             <MiniStatisticsCard
                                 title={{ text: "Favorite Amenity" }}
                                 count={favoriteAmenity || "-"}
                                 icon={{ color: "warning", component: "star" }}
                             />
                         </Grid>
                     </Grid>
                 </MDBox>

                 {/* Row 2: Upcoming Bookings Section */}
                 {upcomingBookings && upcomingBookings.length > 0 && (
                     <MDBox mt={3}>
                         <Card>
                             <MDBox p={3} lineHeight={1}>
                                 <MDTypography variant="h5" fontWeight="medium">
                                     <Icon sx={{ mr: 1, verticalAlign: "middle" }}>schedule</Icon>
                                     Upcoming Bookings
                                 </MDTypography>
                             </MDBox>
                             <MDBox px={3} pb={3}>
                                 <Grid container spacing={2}>
                                     {upcomingBookings.map((booking, index) => (
                                         <Grid item xs={12} md={6} lg={4} key={booking.id || index}>
                                             <Card sx={{ backgroundColor: "#f8f9fa", p: 2 }}>
                                                 <MDBox display="flex" justifyContent="space-between" alignItems="center">
                                                     <MDBox>
                                                         <MDTypography variant="h6" fontWeight="medium">
                                                             {booking.amenity_name}
                                                         </MDTypography>
                                                         <MDTypography variant="button" color="text">
                                                             {new dayjs(booking.date).format("MMM D, YYYY")} • {booking.start_time} - {booking.end_time}
                                                         </MDTypography>
                                                     </MDBox>
                                                     <MDBadge
                                                         variant="gradient"
                                                         badgeContent={booking.status}
                                                         color={booking.status === "confirmed" ? "success" : "warning"}
                                                         size="sm"
                                                         container
                                                     />
                                                 </MDBox>
                                             </Card>
                                         </Grid>
                                     ))}
                                 </Grid>
                             </MDBox>
                         </Card>
                     </MDBox>
                 )}

                 {/* Row 3: Quick Book Section */}
                 {popularAmenities && popularAmenities.length > 0 && (
                     <MDBox mt={3}>
                         <Card>
                             <MDBox p={3} lineHeight={1}>
                                 <MDTypography variant="h5" fontWeight="medium">
                                     <Icon sx={{ mr: 1, verticalAlign: "middle" }}>bolt</Icon>
                                     Quick Book
                                 </MDTypography>
                                 <MDTypography variant="button" color="text">
                                     Book your favorite amenities with one click
                                 </MDTypography>
                             </MDBox>
                             <MDBox px={3} pb={3}>
                                 <Grid container spacing={3}>
                                     {popularAmenities.map((amenity, index) => (
                                         <Grid item xs={12} md={6} lg={3} key={amenity.id || index}>
                                             <MDBox mt={3}>
                                                 <BookingCard
                                                     image={amenity.image || booking1}
                                                     title={amenity.name}
                                                     description={amenity.description || ""}
                                                     price={amenity.price > 0 ? `$${amenity.price} ${amenity.currency || "CAD"}` : "Free"}
                                                     duration={`${amenity.duration || 60} min`}
                                                     action
                                                     bookId={amenity.id}
                                                     buttonText="Book Now"
                                                 />
                                             </MDBox>
                                         </Grid>
                                     ))}
                                 </Grid>
                             </MDBox>
                         </Card>
                     </MDBox>
                 )}

                 {/* Row 4: Booking History */}
                 <MDBox mt={3}>
                     <Card>
                         <MDBox p={3} lineHeight={1}>
                             <MDTypography variant="h5" fontWeight="medium">
                                 <Icon sx={{ mr: 1, verticalAlign: "middle" }}>history</Icon>
                                 My Bookings
                             </MDTypography>
                             <MDTypography variant="button" color="text">
                                 Your recent booking history
                             </MDTypography>
                         </MDBox>
                         <MDBox p={3} lineHeight={1}>
                             {rows && rows.length > 0 ? (
                                 <DataGridView columns={columns} rows={rows} />
                             ) : (
                                 <MDBox textAlign="center" py={4}>
                                     <Icon sx={{ fontSize: 48, color: "text.secondary", mb: 1 }}>event_busy</Icon>
                                     <MDTypography variant="h6" color="text">
                                         No bookings yet
                                     </MDTypography>
                                     <MDTypography variant="button" color="text">
                                         Start by booking an amenity above!
                                     </MDTypography>
                                 </MDBox>
                             )}
                         </MDBox>
                     </Card>
                 </MDBox>
             </MDBox>
         );
     }

    const renderAdminDashboard = () => (
        <MDBox py={3}>
      {/* Row 1: Primary Stats - smaller cards */}
      <MDBox mt={1}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={4} lg={2}>
            <MiniStatisticsCard
              title={{ text: "Today" }}
              count={todayBooking}
              icon={{ color: "info", component: "today" }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MiniStatisticsCard
              title={{ text: "This Month" }}
              count={monthlyBooking}
              icon={{ color: "primary", component: "calendar_month" }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MiniStatisticsCard
              title={{ text: "Daily Avg" }}
              count={dailyRate}
              icon={{ color: "success", component: "trending_up" }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MiniStatisticsCard
              title={{ text: "Members" }}
              count={membersCount}
              icon={{ color: "warning", component: "people" }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MiniStatisticsCard
              title={{ text: "Revenue" }}
              count={`$${revenue}`}
              icon={{ color: "success", component: "attach_money" }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MiniStatisticsCard
              title={{ text: "Busiest Day" }}
              count={busiestDay || "-"}
              icon={{ color: "dark", component: "event" }}
            />
          </Grid>
        </Grid>
      </MDBox>
      {/* Row 2: Busiest Stats */}
      <MDBox mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={4} lg={3}>
            <MiniStatisticsCard
              title={{ text: "Busiest Time" }}
              count={busiestTime || "-"}
              icon={{ color: "info", component: "schedule" }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <MiniStatisticsCard
              title={{ text: "Top Amenity" }}
              count={busiestAmenity || "-"}
              icon={{ color: "error", component: "star" }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <MiniStatisticsCard
              title={{ text: "Top Member" }}
              count={busiestMember || "-"}
              icon={{ color: "warning", component: "person" }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <MiniStatisticsCard
              title={{ text: "Top Unit" }}
              count={busiestUnit || "-"}
              icon={{ color: "primary", component: "apartment" }}
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox mt={6}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsBarChart
                color="info"
                title="website views"
                description="Last Campaign Performance"
                date="campaign sent 2 days ago"
                chart={reportsBarChartData}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsLineChart
                color="success"
                title="daily sales"
                description={
                  <>
                    (<strong>+15%</strong>) increase in today sales.
                  </>
                }
                date="updated 4 min ago"
                chart={sales}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MDBox mb={3}>
              <ReportsLineChart
                color="dark"
                title="completed tasks"
                description="Last Campaign Performance"
                date="just updated"
                chart={tasks}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox mb={3}>
        <Card>
          <MDBox p={3} lineHeight={1}>
            <MDTypography variant="h5" fontWeight="medium">
              Your Bookings
            </MDTypography>
            <MDTypography variant="button" color="text">
              Your recent booking history
            </MDTypography>
          </MDBox>
          <DataTable table={dataTableData} />
        </Card>
      </MDBox>
    </MDBox>
    );
    const renderSuperAdminDashboard = () => (
        <MDBox py={3}>
    {/* Row 1: Primary Stats - smaller cards */}
    <MDBox mt={1}>
      <Grid container spacing={2}>
        <Grid item xs={6} md={4} lg={2}>
          <MiniStatisticsCard
            title={{ text: "Today" }}
            count={todayBooking}
            icon={{ color: "info", component: "today" }}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <MiniStatisticsCard
            title={{ text: "This Month" }}
            count={monthlyBooking}
            icon={{ color: "primary", component: "calendar_month" }}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <MiniStatisticsCard
            title={{ text: "Daily Avg" }}
            count={dailyRate}
            icon={{ color: "success", component: "trending_up" }}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <MiniStatisticsCard
            title={{ text: "Members" }}
            count={membersCount}
            icon={{ color: "warning", component: "people" }}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <MiniStatisticsCard
            title={{ text: "Revenue" }}
            count={`$${revenue}`}
            icon={{ color: "success", component: "attach_money" }}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <MiniStatisticsCard
            title={{ text: "Busiest Day" }}
            count={busiestDay || "-"}
            icon={{ color: "dark", component: "event" }}
          />
        </Grid>
      </Grid>
    </MDBox>
    {/* Row 2: Busiest Stats */}
    <MDBox mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={6} md={4} lg={3}>
          <MiniStatisticsCard
            title={{ text: "Busiest Time" }}
            count={busiestTime || "-"}
            icon={{ color: "info", component: "schedule" }}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <MiniStatisticsCard
            title={{ text: "Top Amenity" }}
            count={busiestAmenity || "-"}
            icon={{ color: "error", component: "star" }}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <MiniStatisticsCard
            title={{ text: "Top Member" }}
            count={busiestMember || "-"}
            icon={{ color: "warning", component: "person" }}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <MiniStatisticsCard
            title={{ text: "Top Unit" }}
            count={busiestUnit || "-"}
            icon={{ color: "primary", component: "apartment" }}
          />
        </Grid>
      </Grid>
    </MDBox>
    <MDBox mt={6}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={6} lg={4}>
        <MDBox mb={3}>
          <ReportsBarChart
            color="info"
            title="website views"
            description="Last Campaign Performance"
            date="campaign sent 2 days ago"
            chart={reportsBarChartData}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <MDBox mb={3}>
          <ReportsLineChart
            color="success"
            title="daily sales"
            description={
              <>
                (<strong>+15%</strong>) increase in today sales.
              </>
            }
            date="updated 4 min ago"
            chart={sales}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <MDBox mb={3}>
          <ReportsLineChart
            color="dark"
            title="completed tasks"
            description="Last Campaign Performance"
            date="just updated"
            chart={tasks}
          />
        </MDBox>
      </Grid>
    </Grid>
    </MDBox>
    <MDBox mb={3}>
    <Card>
      <MDBox p={3} lineHeight={1}>
        <MDTypography variant="h5" fontWeight="medium">
          All Bookings
        </MDTypography>
        <MDTypography variant="button" color="text">
          Recent booking activity across all buildings
        </MDTypography>
      </MDBox>
      <DataTable table={dataTableData} />
    </Card>
    </MDBox>
    </MDBox>
    );

    const renderMain = () => {
        const currentRole = getUserRole().toLowerCase();
        if (currentRole === "user" || currentRole === "member") {
          return renderUserDashboard();
        }
        if (currentRole === "staff") {
          return renderStaffDashboard();
        }
        if (currentRole === "admin") {
          return renderStaffDashboard();
        }
        if (currentRole === "super_admin") {
          return renderStaffDashboard();
        }
        return "";
    };

    return (
        <DashboardLayout>
          <DashboardNavbar />
          {renderMain()}
          <Footer />
        </DashboardLayout>
    );
}

export default Analytics;
